// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"74d9930b","198":"1677fe04","453":"227c1910"}[chunkId] + ".chunk.js";
};